export const SEO_DEFAULTS = {
  siteName: 'Trendy Quest Collection',
  siteUrl: 'https://trendyquest.protostarkenya.com',
  defaultTitle: 'Trendy Quest Collection | Stylish Footwear in Nairobi, Kenya',
  defaultDescription:
    'Shop Trendy Quest Collection for men, women, kids shoes and clothing in Kenya with fast delivery, everyday comfort, and easy WhatsApp ordering.',
  locale: 'en_KE',
  themeColor: '#13833A',
  twitterHandle: '@trendyquesty',
  defaultImage: '/homepage banner.jpg',
  socialProfiles: [
    'https://web.facebook.com/cvsix.collection',
    'https://www.instagram.com/trend_yquest/',
    'https://www.tiktok.com/@trendyquesty',
  ],
};

export const getSiteUrl = () => {
  const value = process.env.NEXT_PUBLIC_SITE_URL?.trim();
  const siteUrl = value || SEO_DEFAULTS.siteUrl;
  return siteUrl.endsWith('/') ? siteUrl.slice(0, -1) : siteUrl;
};

export const getFacebookAppId = () => process.env.NEXT_PUBLIC_FACEBOOK_APP_ID?.trim() || '';

export const getAbsoluteUrl = (path = '') => {
  const siteUrl = getSiteUrl();
  if (!siteUrl) return '';
  if (!path) return siteUrl;

  if (/^https?:\/\//i.test(path)) {
    return encodeURI(path);
  }

  const normalizedPath = path.startsWith('/') ? path : `/${path}`;
  return `${siteUrl}${encodeURI(normalizedPath)}`;
};

export const resolveImageValue = (imagePath) => {
  if (!imagePath) return '';
  if (typeof imagePath === 'string') return imagePath.trim();
  if (typeof imagePath === 'object') {
    if (typeof imagePath.src === 'string' && imagePath.src.trim()) return imagePath.src.trim();
    if (typeof imagePath.url === 'string' && imagePath.url.trim()) return imagePath.url.trim();
    if (typeof imagePath.path === 'string' && imagePath.path.trim()) return imagePath.path.trim();
    if (typeof imagePath.image === 'string' && imagePath.image.trim()) return imagePath.image.trim();
  }

  return '';
};

export const getAbsoluteImageUrl = (imagePath) => {
  const resolvedImagePath = resolveImageValue(imagePath);
  if (!resolvedImagePath) return '';
  if (/^https?:\/\//i.test(resolvedImagePath)) {
    return encodeURI(resolvedImagePath);
  }

  return getAbsoluteUrl(resolvedImagePath);
};

const normalizeCloudinaryImageUrl = (url) => {
  if (!url) return url;
  const cloudinaryUploadSegment = '/upload/';
  if (!url.includes('res.cloudinary.com') || !url.includes(cloudinaryUploadSegment)) {
    return url;
  }

  return url.replace(cloudinaryUploadSegment, '/upload/c_fill,w_1200,h_630,q_auto,f_auto/');
};

export const getAbsoluteSocialImageUrl = (imagePath) => {
  const imageUrl = getAbsoluteImageUrl(imagePath);
  if (!imageUrl) return '';
  return normalizeCloudinaryImageUrl(imageUrl);
};

export const getImageMimeType = (imagePath = '') => {
  const pathname = String(imagePath || '').split('?')[0].toLowerCase();

  if (pathname.endsWith('.png')) return 'image/png';
  if (pathname.endsWith('.webp')) return 'image/webp';
  if (pathname.endsWith('.gif')) return 'image/gif';
  if (pathname.endsWith('.avif')) return 'image/avif';

  return 'image/jpeg';
};
